/** 肺结节患者管理统一使用的标签范围（不含糖尿病/高血压等其他慢病）。 */
export const LUNG_PATIENT_LIMIT_LABELS = [
  'lungcancer',
  'lungcancer_danger',
  'lungcancer_danger_tumor',
  'lungcancer_danger_mass',
  'lungcancer_danger_nodule',
  'lungcancer_danger_nodule_low',
  'lungcancer_danger_nodule_high'
];

/** 疾病标签 code -> 展示名 */
export const LUNG_LABEL_DISPLAY_NAMES = {
  lungcancer: '肺癌',
  lungcancer_danger: '肺癌高危',
  lungcancer_danger_tumor: '肺肿瘤高危',
  lungcancer_danger_mass: '肺占位高危',
  lungcancer_danger_nodule: '肺结节高危',
  lungcancer_danger_nodule_low: '肺结节低危',
  lungcancer_danger_nodule_high: '肺结节高危',
  easy_lungcancer: '肺癌易患'
};

export const LUNG_DISEASE_CATEGORY_OPTIONS = [
  {
    value: '{"label": "lungcancer","filter":"and","operator":"in"}',
    label: '肺癌管理'
  }
];

export const LUNG_DISEASE_CATEGORY_OPTIONS_DANGER = [
  {
    value: '{"label": "lungcancer_danger","filter":"and","operator":"in"}',
    label: '肺癌管理'
  }
];

export function resolveLungLimitLabels(selectedLabels) {
  const selected = (selectedLabels || [])
    .map(item => item && item.label)
    .filter(Boolean);
  if (!selected.length) {
    return [...LUNG_PATIENT_LIMIT_LABELS];
  }
  // 仅保留肺相关标签，避免病种筛选串到其他慢病
  const lungSelected = selected.filter(label => LUNG_PATIENT_LIMIT_LABELS.includes(label));
  return lungSelected.length ? lungSelected : [...LUNG_PATIENT_LIMIT_LABELS];
}

/** 将患者 labels 转为疾病标签展示文案；无系统标签时回退 diseaseGroup。 */
export function formatLungDiseaseLabels(labels, diseaseGroup) {
  const names = (labels || [])
    .map(item => item && item.label)
    .filter(Boolean)
    .map(code => LUNG_LABEL_DISPLAY_NAMES[code] || null)
    .filter(Boolean);
  const unique = [...new Set(names)];
  if (unique.length) {
    return unique.join('、');
  }
  return diseaseGroup || '';
}
